export default __webpack_public_path__ + "static/media/astal.eec729ca.jpg";